// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2pNYE","colMin":"styles_colMin__CGbYm","colCheckbox":"styles_colCheckbox__2SUMD"};